import { FC, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, TextField } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import Swal from 'sweetalert2';
import { CustomerCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { RTM_D } from './SCUIRptTopicManagementDrawerContent.classes';
interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
    onUpdate?: any;
}

export const SCUIRptTopicManagementDrawerContent: FC<IProps> = ({ selectedRow, onCloseMenu, onUpdate }) => {
    const handleChangeTitle = (event: any) => {
        setTopicName(event.target.value);
    };
    const handleChangeText = (event: any) => {
        setTopicControlDays(event.target.value);
    };
    const UpdateRptTopic = () => {
        Swal.fire({
            text: 'Güncellemek istediğinizden emin misiniz',
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.rptTopicId = selectedRow.id;
                params.topicName = topicName;
                params.topicControlDays = topicControlDays;
                if (topicName && topicName?.trim().length > 0 && topicControlDays >= 0) {
                    CustomerCommand.UpdateRptTopic(params)
                        .then(() => {
                            onUpdate();
                            Swal.fire(t('general.updated'), ' ', 'success');
                            onUpdate();
                            onCloseMenu();
                        })
                        .catch((error: any) => {
                            console.log('Hata :>> ', error);
                        });
                } else {
                    Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
                }
            }
        });
    };
    const CreateRptTopic = async () => {
        let params: any = {};
        params.topicName = topicName;
        params.topicControlDays = topicControlDays;
        if (topicName && topicName?.trim().length > 0 && topicControlDays >= 0) {
            CustomerCommand.CreateRptTopic(params)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    onUpdate();
                    onCloseMenu();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const { t } = useTranslation();
    const [topicName, setTopicName] = useState(selectedRow.topicName);
    const [topicControlDays, setTopicControlDays] = useState(selectedRow.topicControlDays);
    return (
        <Grid className={['designCollectiveselectedRowGrid', RTM_D.root].filter(Boolean).join(' ')}>
            <Grid className={RTM_D.headerRow} container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className={RTM_D.titleCol}
                    sx={{ paddingLeft: '3rem' }}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11,
                    }}
                >
                    <p
                        className={RTM_D.title}
                        style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: 'rgba(0,0,0,0.85)' }}
                    >
                        {selectedRow?.topicName ? t('rptTopic.editRptTopic') : t('rptTopic.createRptTopic')}
                    </p>
                </Grid>

                <Grid
                    className={RTM_D.closeCol}
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon className={['svg_icons', RTM_D.closeIcon].filter(Boolean).join(' ')} onClick={onCloseMenu} />
                </Grid>
            </Grid>
            <Grid className={RTM_D.formSection} container sx={{ padding: '3rem' }}>
                <br />

                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={RTM_D.fieldTopicName}
                        label={t('rptTopic.topicName')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={selectedRow?.topicName}
                        onChange={handleChangeTitle}
                    />
                </Grid>

                <Grid
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={RTM_D.fieldTopicControlDays}
                        label={t('rptTopic.topicControlDays')}
                        margin="dense"
                        id="parameterValue"
                        type="number"
                        fullWidth
                        defaultValue={selectedRow?.topicControlDays}
                        onChange={handleChangeText}
                    />
                </Grid>
                <Grid
                    container
                    sx={{ marginTop: '2rem' }}
                    size={{
                        xs: 6,
                        sm: 6,
                    }}
                ></Grid>
                <Grid
                    className={RTM_D.footerRow}
                    container
                    justifyContent={'flex-end'}
                    sx={{ marginTop: '2rem' }}
                    size={{
                        xs: 6,
                        sm: 6,
                    }}
                >
                    {selectedRow.topicName ? (
                        <SCUIButton
                            className={RTM_D.updateButton}
                            text={t('general.update')}
                            type="primary"
                            sizeType="fixed"
                            size={'s'}
                            style={{ borderRadius: '8px', fontWeight: 600, fontSize: '12px' }}
                            onClick={() => UpdateRptTopic()}
                        ></SCUIButton>
                    ) : (
                        <SCUIButton
                            className={RTM_D.saveButton}
                            text={t('rptTopic.drawer.save')}
                            type="primary"
                            sizeType="fixed"
                            size={'s'}
                            style={{ borderRadius: '8px', fontWeight: 600, fontSize: '12px' }}
                            onClick={() => CreateRptTopic()}
                        ></SCUIButton>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};
